import { useExistingContext } from 'providers/useExistingContext';
import { createContext } from 'react';
import type { ConfirmationModalContextType } from './typings';

export const ConfirmationModalContext = createContext<ConfirmationModalContextType>(() => Promise.resolve());

export const useConfirmationModal = () => useExistingContext(ConfirmationModalContext);
